export default class Easing {
    public static easeIn(current: number, goal: number) {
        const result = Math.round((goal / Math.log(goal + 1)) * Math.log(current + 1));
        return isNaN(result) ? 0 : result;
    }
}
